import React from 'react';
import { Image, View } from 'react-native';
import { Text } from 'react-native-web';
import {
  Android,
  getSubCategory,
  getSubCategoryId,
  just_split_100,
  success_image,
  successInputTextPerFlow,
  text_message,
} from '../../../../../utils/DictionaryManagementUtils';
import {
  getImageByKey,
  img_typing_ios,
} from '../../../../../utils/ImagesManagementUtils';
import LargeBtnWithFilling from '../../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import FullPageSimulator from '../../FullPageSimulator';
import LargeTextWithSpecialFont from '../../../AuxiliaryComponent/TextComponent/LargeTextWithSpecialFont';
import ParagraphSecondaryBackground from '../../../AuxiliaryComponent/TextComponent/ParagraphSecondaryBackground';
import { textLink_9_3 } from '../../../AuxiliaryComponent/TextComponent/TextStyle';

const TransferSuccessFP = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  withXtendStr,
  TopTitle,
  largeText,
  withExtraHeightForTitle,
  normalBackgroundImage,
  isShareReceipt,
  slideshowRefs,
  backToMenu,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategory = getSubCategory(subCategoryId);
  const { services } = globJSON.configurations;
  const { success } = services[subCategoryId];
  const showShare = success.enable_customer_to_share_transaction;
  const shareMethod = success.sharing_method;
  const sharingByChat = showShare && (shareMethod === text_message || isShareReceipt);
  const myStyles = {
    successLogo: {
      alignSelf: 'center',
      width: 58,
      height: 58,
    },
    linkStyle: {
      paddingVertical: 10,
      textAlign: 'center',
    },
    typingImage: {
      width: 240,
      height: 28,
      marginTop: 205,
    },
    paragraphStyle: {
      marginTop: 198,
      marginRight: 40,
      marginLeft: 40,
      fontSize: 11,
      position: 'absolute',
    },
    largeTextContainer: {
      paddingVertical: 10,
      alignSelf: 'center',
    },
    InputTextPerFlowStyle: {
      position: 'absolute',
      fontSize: 10.4,
      marginTop: 212,
      marginLeft: 40,
    },
    imageTyping: {
      position: 'absolute',
      width: '100%',
    },

  };
    //= ====================================================================
  return (
    <View>
      <FullPageSimulator
        globJSON={globJSON}
        simPlatform={simPlatform}
        TopTitle={TopTitle}
        withExtraHeightForTitle={withExtraHeightForTitle}
        hideArrow
        slideshowRefs={slideshowRefs}
      >
        <Image
          fadeDuration={0}
          resizeMode="contain"
          style={myStyles.successLogo}
          source={getImageByKey(globJSON.configurations.general.success_image, success_image)}
        />
        <View style={myStyles.largeTextContainer}>
          <LargeTextWithSpecialFont
            globJSON={globJSON}
            simPlatform={simPlatform}
            language={language}
            txt={largeText}
          />
        </View>
        {withXtendStr
                && (
                <ParagraphSecondaryBackground
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  txt={withXtendStr}
                />
                )}
        {showShare && (
        <LargeBtnWithFilling
          globJSON={globJSON}
          simPlatform={simPlatform}
          subCategoryId={subCategoryId}
          inputText={sharingByChat ? success.share_in_chat : success.share_receipt}
        />
        )}
        {backToMenu && (
        <Text style={[textLink_9_3(globJSON, simPlatform), myStyles.linkStyle]}>
          {services.menu.layout_menu_screen ? success.go_back_to_menu : success.done}
        </Text>
        )}
      </FullPageSimulator>
      {!normalBackgroundImage && simPlatform !== Android
          && (
            <View style={myStyles.imageTyping}>
              <Image
                fadeDuration={0}
                style={myStyles.typingImage}
                source={img_typing_ios}
              />
              <Text style={myStyles.InputTextPerFlowStyle}>{successInputTextPerFlow[subCategory]}</Text>
            </View>
          )}
      {normalBackgroundImage && simPlatform !== Android && (<Text style={myStyles.paragraphStyle}>{just_split_100}</Text>)}
    </View>
  );
};

export default TransferSuccessFP;
